import { isAxiosError } from "axios";

export interface ApiFieldError {
  field?: string;
  message: string;
}

/** Thrown by unwrap() when the envelope's `success` is false — a real business/validation failure, not a network error. */
export class ApiBusinessError extends Error {
  code: string;
  fieldErrors: ApiFieldError[];

  constructor(code: string, message: string, fieldErrors: ApiFieldError[] = []) {
    super(message);
    this.name = "ApiBusinessError";
    this.code = code;
    this.fieldErrors = fieldErrors;
  }
}

/** Extracts a human-readable message from any error a mutation/query can throw. */
export function apiErrorMessage(error: unknown): string {
  if (error instanceof ApiBusinessError) {
    if (error.fieldErrors.length > 0) {
      return error.fieldErrors
        .map((e) => (e.field ? `${e.field}: ${e.message}` : `${error.code}: [${e.message}]`))
        .join("; ");
    }
    const cleanMsg = error.message.startsWith("Request failed:")
      ? error.message.replace(/^Request failed:\s*/, "")
      : error.message;
    return cleanMsg === error.code ? error.code : `${error.code}: [${cleanMsg}]`;
  }
  if (isAxiosError(error)) {
    if (error.response?.status === 401) return "Your session expired — please log in again.";
    if (error.code === "ERR_NETWORK") return "Can't reach the server. Check your connection and try again.";
    return error.message || "Something went wrong.";
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}
